import React, { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { FaEye, FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { useSearchParams, useNavigate } from "react-router-dom";

const NonBidUsersTillDate = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const date = searchParams.get("date"); // ?date=28-12-2025
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (date) fetchUsers();
  }, [date]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        "/api/auth/total-not-player",
        { params: { date } }
      );

      if (res.data?.success) {
        setUsers(res.data.data || []);
      } else {
        setError("Failed to fetch users");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-lg shadow-md p-6">

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">
            Non-Bid Users
          </h2>
          {date && (
            <span className="text-sm bg-blue-100 text-blue-700 px-3 py-1 rounded">
              Till Date: {date}
            </span>
          )}
        </div>

        {/* LOADING */}
        {loading && (
          <div className="flex justify-center py-10">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* ERROR */}
        {!loading && error && (
          <p className="text-red-600 text-center py-6">{error}</p>
        )}

        {/* TABLE */}
        {!loading && !error && users.length > 0 && (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 border text-left">#</th>
                  <th className="px-4 py-2 border text-left">Username</th>
                  <th className="px-4 py-2 border text-left">Mobile</th>
                  <th className="px-4 py-2 border text-left">Wallet</th>
                  <th className="px-4 py-2 border text-left">Status</th>
                  <th className="px-4 py-2 border text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {users.map((user, index) => (
                  <tr key={user._id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{index + 1}</td>

                    <td className="px-4 py-2 border font-medium text-blue-600">
                      {user.userName}
                    </td>

                    <td className="px-4 py-2 border">
                      {user.phone}
                    </td>

                    <td className="px-4 py-2 border text-green-600 font-semibold">
                      ₹ {user.walletBalance}
                    </td>

                    <td className="px-4 py-2 border">
                      {user.status ? (
                        <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">
                          Active
                        </span>
                      ) : (
                        <span className="px-2 py-1 text-xs rounded bg-red-100 text-red-700">
                          Inactive
                        </span>
                      )}
                    </td>

                    {/* ACTION COLUMN */}
                    <td className="px-4 py-2 border text-center">
                      <div className="flex justify-center gap-4 text-lg">

                        {/* VIEW */}
                        <button
                          onClick={() =>
                            navigate(
                              `/admin/user-management/user-details/${user._id}`
                            )
                          }
                          className="text-blue-600 hover:text-blue-800"
                          title="View Profile"
                        >
                          <FaEye />
                        </button>

                        {/* WHATSAPP */}
                        <a
                          href={`https://wa.me/91${user.phone}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-green-600 hover:text-green-800"
                          title="WhatsApp"
                        >
                          <FaWhatsapp />
                        </a>

                        {/* CALL */}
                        <a
                          href={`tel:${user.phone}`}
                          className="text-gray-700 hover:text-black"
                          title="Call"
                        >
                          <FaPhoneAlt />
                        </a>

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* EMPTY */}
        {!loading && !error && users.length === 0 && (
          <p className="text-center text-gray-500 py-6">
            No non-bid users found till selected date
          </p>
        )}

      </div>
    </div>
  );
};

export default NonBidUsersTillDate;
